import { useEffect, useRef } from "react";
import { animate, onScroll, stagger } from "animejs";
import useReducedMotion from "../../hooks/useReducedMotion";
import "./PixelDivider.css";

const COLORS = [
	"var(--primary-color)",
	"var(--primary-color)",
	"var(--secondary-color)",
	"var(--tertiary-color)",
	"var(--text-color)",
	"var(--primary-color)",
	"var(--primary-color)",
	"var(--primary-color)",
];

export default function PixelDivider({ label }) {
	const rootRef = useRef(null);
	const reduced = useReducedMotion();

	useEffect(() => {
		const root = rootRef.current;
		if (!root || reduced) return;
		const squares = root.querySelectorAll(".pd-sq");
		squares.forEach((s) => (s.style.opacity = "0"));

		let observer;
		try {
			observer = onScroll({
				container: window,
				target: root,
				enter: "bottom-=10% top",
				leave: "top bottom",
				sync: false,
			});
		} catch (_) {
			observer = undefined;
		}

		animate(squares, {
			opacity: [0, 1],
			translateY: [8, 0],
			delay: stagger(70),
			duration: 320,
			ease: "outQuad",
			autoplay: observer ?? true,
		});
	}, [reduced]);

	return (
		<div className="pd" ref={rootRef} aria-hidden="true">
			<div className="pd-row">
				{COLORS.map((c, i) => (
					<span
						className="pd-sq"
						key={i}
						style={{ background: c }}
					/>
				))}
			</div>
			{label && <div className="pd-label mono">{label}</div>}
		</div>
	);
}
